<template>
	<div class="auth register">
		<div class="sk-h1 sk-h1--large">Welcome!</div>
		<div class="sk-note sk-note--margin-l">Sign Up by entering the details below.</div>
		<form @submit.prevent="validateAndSubmit" class="form-auth">
			<input-text autocomplete="name" v-model="model.fullname" name="login_fullname" :placeholder="$t('labels.auth.fullname')" rules="required|alpha_spaces"/>
			<input-text autocomplete="email" v-model="model.email" name="login_email" :placeholder="$t('labels.auth.email')" rules="required|email"/>
			<input-password v-model="model.password" autocomplete="new-password" name="password" :placeholder="$t('labels.auth.password')" rules="required|min:8"/>
			<input-password v-model="model.confirm_password" autocomplete="new-password" name="confirm_password" :placeholder="$t('labels.auth.confirm_password')" :rules="'required|confirmed:'+model.password"/>
			<error-box v-if="form_error" :error="form_error"/>
			<input-checkbox name="terms-and-use" v-model="model.terms" rules="authorize" :placeholder="$t('labels.general.use_policy')">
				{{ $t('base.auth.msg_use_policy') }} <span class="link" @click.prevent="openUsePolicy">{{ $t('labels.general.use_policy') }}</span>.
			</input-checkbox>
			<input-checkbox name="privacy-policy" v-model="model.privacy" rules="authorize" :placeholder="$t('labels.general.privacy_policy')">
				{{ $t('base.auth.msg_privacy_policy') }} <span class="link" @click.prevent="openPrivacyPolicy">{{ $t('labels.general.privacy_policy') }}</span>.
			</input-checkbox>
			<div class="form-group">
				<button-submit :loading="loading">{{ $t('buttons.auth.create_account') }}</button-submit>
			</div>
			<span class="margin-top">Already have an account? <router-link :to="{ name: 'AuthLogin'}">{{ $t('base.auth.login') }}</router-link></span>
		</form>
	</div>
</template>

<script>
export default {
	data () {
		return {
			loading: false,
			model: {
				fullname: '',
				email: '',
				password: '',
				confirm_password: '',
				terms: false,
				privacy: false,
			},
			form_error: null
		}
	},
	methods: {
		openUsePolicy() {
			this.$appModalAsync.start({size: 'xl'})
			this.$api.statics.getStaticContent(this, 'use-policy')
				.then(response => {
					const data = response.body.length ? response.body : []
					const current = data.find(ele => ele.lang == this.$i18n.locale) || {}
					this.$appModalAsync.show({
						title: this.$t('labels.general.use_policy'),
						message: current.content
					})
				})
				.catch((error) => {
					console.log(error)
					this.$appModalAsync.end()
				})
		},
		openPrivacyPolicy() {
			this.$appModalAsync.start({size: 'xl'})
			this.$api.statics.getStaticContent(this, 'privacy-policy')
				.then(response => {
					const data = response.body.length ? response.body : []
					const current = data.find(ele => ele.lang == this.$i18n.locale) || {}
					this.$appModalAsync.show({
						title: this.$t('labels.general.privacy_policy'),
						message: current.content
					})
				})
				.catch((error) => {
					console.log(error)
					this.$appModalAsync.end()
				})
		},
		validateAndSubmit () {
			this.$validator.validateAll().then(result => {
				if (result) this.submit()
			})
		},
		submit () {
			this.loading = true
			const credentials = {
				fullname: this.model.fullname,
				email: this.model.email,
				password: this.model.password
			}
			this.$api.auth.register(this, credentials).then(response => {
				this.$log.info('user register', 'auth.register OK', response)()
				this.$router.push({ name: 'AuthLogin' })
			}).catch(errors => {
				this.$log.error('user register', 'auth.register ERROR', errors)()
				this.form_error = errors
			}).finally(() => {
				this.loading = false
			})
		}
	},
	beforeCreate () {
		this.$title(this.$t('base.auth.signup'))
	}
}
</script>

<style scoped>
.link {
	text-decoration: underline;
	cursor: pointer;
}
.margin-top {
	margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/AuthRegister.vue